(function() {
  const attributes = {
    password: 'data-input-password',
  }

  const selectors = {
      animatedLabelsWrapper: '[data-input-animated-label]',
      fancySelects: '[data-choices-select]',
      passwordInput: `[${attributes.password}]`,
      iconClass: '.input-icon'
  }

  const toggleLabelAnimation = function(e, status) {
    const target = e.target;
    const wrapper = e.currentTarget;
    if(target.tagName.toUpperCase() != 'INPUT' && !target.closest('.choices')) return;

    if(!$(target).val().trim()) {
      $(wrapper).attr('data-input-animated-label', status);
    };
  }

  // Adding animation
  $('form').on('focus', selectors.animatedLabelsWrapper, function(e) {
      toggleLabelAnimation(e, true);
  });

  //Removing animation
  $('form').on('blur', selectors.animatedLabelsWrapper, function(e) {
   toggleLabelAnimation(e, false);
  });

  const fancySelectsNodes = document.querySelectorAll(selectors.fancySelects);
  if(fancySelectsNodes.length) {
    const selects = Array.from(fancySelectsNodes);
    selects.map(selectWrapper => {
      const select = selectWrapper.querySelector('select');
      if(select) {
        new Choices(select, {
            shouldSort: false,
            searchEnabled: false,
            itemSelectText: ''
          }
        );

        selectWrapper.addEventListener(
          'choice',
          function(e) {
            selectWrapper.classList.add('first-choice--happened');
          },
          false,
        );
      }
    });
  }

  const passwordInputs = document.querySelectorAll(selectors.passwordInput);
  if(passwordInputs.length) {
    const pwInputs = Array.from(passwordInputs);
    pwInputs.map(wrapper => {
      wrapper.addEventListener('click', (e) => {
        if(e.target.closest(selectors.iconClass)) {
          let visibilityAttributeValue = '';
          let inputType = 'password';
          const input = wrapper.querySelector('input');
          const isVisible = input.getAttribute('type') !== 'password';

          if(!isVisible) {
            visibilityAttributeValue = 'visible';
            inputType = 'text';
          }

          input.setAttribute('type', inputType);
          wrapper.setAttribute(attributes.password, visibilityAttributeValue);
        }
      });
    });
  }
})();
